import { Fragment } from 'react';

import useClubStaff from './UseClubStaff';

import ClubStaffGrid from './components/grids/clubStaff/ClubStaffGrid';
import ClubStaffLoadingModal from './components/dialogs/loadingModal/ClubStaffLoadingModal';

import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';

import { LOADING_MSG, SAVING_MSG } from '@usas/ui-web/utils/Constants';

const ClubStaffWrite = () => {
  const {
    isLoading,
    isSaving,
    isGridLoading,
    gridData,
    state,
    deleteModalState,
    onAddClicked,
    onEditClicked,
    onDeleteClicked,
    onDeleteModalConfirmClicked,
    onDeleteModalCancelClicked
  } = useClubStaff();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Club Staff</Headings.H3>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 usas-extra-bottom-margin">
          <ClubStaffGrid
            data={gridData}
            isLoading={isGridLoading}
            onAddClicked={onAddClicked}
            onEditClicked={onEditClicked}
            onDeleteClicked={onDeleteClicked} />
        </div>
      </div>
      <PopUpModal
        widthPct={90}
        maxWidth={720}
        title={deleteModalState.isRegistrationRole === true ? 'Cannot Remove Registration Role' : deleteModalState.isLastRole === true ? 'Remove Staff Member?' : 'Remove Staff Role?'}
        displayPopUp={deleteModalState.displayModal}
        onModalCanceled={onDeleteModalCancelClicked}>
        <div className="row">
          <div className="col-xs-12">
            {deleteModalState.isRegistrationRole === true
              ? <p>{`${deleteModalState.orgRoleName} is a registration role and cannot be removed from ${deleteModalState.personName}. To remove ${deleteModalState.personName} from this club's staff please initiate a transfer from the "Non Athlete Roster" pill.`}</p>
              : deleteModalState.isLastRole === true
                ? <p>{`Removing ${deleteModalState.personName}'s last role(${deleteModalState.orgRoleName}) will remove them from this club's staff.`}</p>
                : <p>{`Remove ${deleteModalState.orgRoleName} role from ${deleteModalState.personName}?`}</p>
            }
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin">
            {deleteModalState.isRegistrationRole !== true &&
              <Fragment><PrimaryButton type="button" onClick={onDeleteModalConfirmClicked}>{deleteModalState.isLastRole === true ? 'Remove Staff Member' : 'Remove Staff Role'}</PrimaryButton>&nbsp;</Fragment>
            }
            <SecondaryButton type="button" onClick={onDeleteModalCancelClicked}>{deleteModalState.isRegistrationRole === true ? 'Close' : 'Cancel'}</SecondaryButton>
          </div>
        </div>
      </PopUpModal>
      <ClubStaffLoadingModal
        isError={state.pageErrorMessage !== ''}
        errorMessage={state.pageErrorMessage}
        isLoading={isSaving || isLoading}
        loadingMessage={isSaving ? SAVING_MSG : LOADING_MSG} />
    </Fragment>
  );
};

export default ClubStaffWrite;